module.exports = __webpack_public_path__ + "img/1280.87f1042c.svg";